import { tns } from 'tiny-slider/src/tiny-slider';

const circuits_slider = document.querySelectorAll('[data-behaviour~="circuits-slider"]');

if (circuits_slider.length > 0) {
    circuits_slider.forEach(slider => {
        tns({
            container: slider,
            loop: false,
            nav: false,
            mouseDrag: true,
            responsive: {
                0: {
                    items: 2,
                },
                1024: {
                    items: 4,
                },
                1240: {
                    items: 7,
                },
            },
        });
    });
}

const database_slider = document.querySelectorAll('[data-behaviour~="database-slider"]');

if (database_slider.length > 0) {
    database_slider.forEach(slider => {
        tns({
            container: slider,
            loop: true,
            nav: false,
            gutter: 22,
            mouseDrag: false,
            responsive: {
                0: {
                    items: 1.5,
                },
                678: {
                    items: 2.5,
                },
                1024: {
                    items: 3.5,
                },
                1240: {
                    items: 4.5,
                },
            },
        });
    });
}

const database_slider_nested = document.querySelectorAll('[data-behaviour~="database-slider-nested"]');

if (database_slider_nested.length > 0) {
    database_slider_nested.forEach(slider => {
        tns({
            container: slider,
            loop: true,
            items: 1,
            mouseDrag: true,
            controls: false,
        });
    });
}

const author_slider = document.querySelectorAll('[data-behaviour~="author-slider"]');

if (author_slider.length > 0) {
    author_slider.forEach(slider => {
        tns({
            container: slider,
            loop: true,
            nav: false,
            gutter: 32,
            mouseDrag: true,
            responsive: {
                0: {
                    items: 1,
                },
                321: {
                    items: 2,
                },
                769: {
                    items: 3,
                },
                1025: {
                    items: 5,
                },
            },
        });
    });
}

const mobile_slider = document.querySelectorAll('[data-behaviour~="mobile-slider"]');

if (mobile_slider.length > 0) {
    mobile_slider.forEach(slider => {
        tns({
            autoHeight: true,
            container: slider,
            loop: false,
            items: 1.1,
            gutter: 12,
            nav: false,
            controls: false,
            responsive: {
                0: {
                    disable: false,
                },
                679: {
                    disable: true,
                },
            },
        });
    });
}

const cta_slider = document.querySelectorAll('[data-behaviour~="cta-slider"]');

if (cta_slider.length > 0) {
    cta_slider.forEach(slider => {
        tns({
            autoHeight: true,
            container: slider,
            autoplay: true,
            loop: true,
            autoplayButtonOutput: false,
            items: 1,
            nav: false,
            controls: false,
            responsive: {
                0: {
                    disable: false,
                },
                768: {
                    disable: true,
                },
            },
        });
    });
}

const news_slider = document.querySelectorAll('[data-behaviour~="news-slider"]');

if (news_slider.length > 0) {
    news_slider.forEach(slider => {
        tns({
            autoplay: true,
            autoplayButtonOutput: false,
            container: slider,
            loop: true,
            items: 1,
            nav: false,
            mouseDrag: false,
        });
    });
}

const simple = document.querySelectorAll('[data-behaviour~="simple-slider"]');

if (simple.length > 0) {
    simple.forEach(slider => {
        tns({
            container: slider,
            loop: true,
            items: 1,
            mouseDrag: true,
            controls: false,
        });
    });
}

const features_slider = document.querySelectorAll('[data-behaviour~="features-slider"]');

if (features_slider.length > 0) {
    features_slider.forEach(slider => {
        tns({
            autoHeight: true,
            container: slider,
            loop: false,
            nav: false,
            mouseDrag: true,
            responsive: {
                0: {
                    items: 1,
                },
                679: {
                    items: 2,
                },
            },
        });
    });
}

const product_carousel = document.querySelectorAll('[data-behaviour~="product-carousel"]');

if (product_carousel.length > 0) {
    product_carousel.forEach(slider => {
        tns({
            container: slider,
            loop: true,
            items: 4,
            nav: false,
            controls: true,
            responsive: {
                0: {
                    items: 1,
                },
                678: {
                    items: 2,
                },
                1024: {
                    items: 3,
                },
                1240: {
                    items: 4,
                },
            },
        });
    });
}
